export default {
  accumulateTotal: function (accumulator, invoice) {
    return accumulator + invoice.total;
  },

  accumulateAmountDue: function (accumulator, invoice) {
    return accumulator + invoice.amount_due;
  },
};

/**
 * Checks that the input value has no more decimals than the expected precision
 * @param {(number|string)} value Number to validate
 * @param {number} [expectedPrecision=2] Defaults to 2, meaning the default precision is 10^-2
 * @returns {boolean}
 *
 * @example
 *  validDecimal(10.045)       // returns `false`
 *
 *  validDecimal(10.045, 3)    // returns `true`
 *
 *  validDecimal(100001.04, 2) // returns `true`
 */
export function validDecimal(value, expectedPrecision = 2) {
  if (value === '') return true;

  const regex = new RegExp(`^\\d*(\\.\\d{0,${expectedPrecision}})?$`);
  return regex.test(value);
}
